export default "__VITE_ASSET__CbZDMdQ9__"